import { EVoxRoles } from 'providers/declare';

export type TUserType = 'client' | 'manager' | null;

/** Получить тип пользователя в зависимости от его роли */
export function getUserTypeByRole(role: EVoxRoles): TUserType {
    if (role === EVoxRoles.MANAGER) return 'manager';
    if ([EVoxRoles.CLIENT, EVoxRoles.GUEST].includes(role)) return 'client';

    return null;
}
